/* eslint-disable no-console */
import React from "react";
import { useDispatch } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "../../atoms";
import { openModal } from "../../../redux/data/modals/modalReducer";
import { PageToolbar } from "../../molecules";

interface IPickUpLocationListToolbarProps {
  searchName: string;
  onSearchNameChange: (value: string) => void;
}

export const PickUpLocationListToolbar: React.FC<
  IPickUpLocationListToolbarProps
> = ({ searchName, onSearchNameChange }) => {
  const dispatch = useDispatch();
  const handelAddBoard = () => {
    dispatch(
      openModal({
        modalType: "AddPickUpLocationModal",
        modalProps: { title: "Add PickUpLocation Form" },
      })
    );
  };

  return (
    <PageToolbar>
      <Button
        type="primary"
        onClick={handelAddBoard}
        block
        icon={<PlusOutlined />}
        className="page-toolbar-btn"
      >
        Add PickUpLocation
      </Button>

      <div className="page-toolbar-right-children-elements">
        <Input.Search
          placeholder="Search by pickup location name"
          allowClear
          value={searchName}
          onChange={(e) => onSearchNameChange(e.target.value)}
          style={{ width: 320 }}
        />
      </div>
    </PageToolbar>
  );
};
